import React, { useState, useEffect } from 'react';
import { Switch } from '@/components/ui/switch';
import { LayoutTemplate } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSelector } from 'react-redux';

const LayoutSwitcher: React.FC = () => {
	const auth = useSelector((state) => state.auth);

	const [showNewLayout, setShowNewLayout] = useState<boolean>(() => {
		const savedState = localStorage.getItem('showNewLayout');
		return savedState ? JSON.parse(savedState) : false;
	});

	useEffect(() => {
		localStorage.setItem('showNewLayout', JSON.stringify(showNewLayout));
	}, [showNewLayout]);

	const handleToggle = () => {
		const newState = !showNewLayout;
		setShowNewLayout(newState);
		localStorage.setItem('showNewLayout', JSON.stringify(newState));
		window.location.assign('/');
	};

	if (auth.reseller) {
		return null;
	}

	return (
		<div className="flex items-center space-x-2 justify-between w-full">
			<div className="flex items-center space-x-2">
				{showNewLayout && <LayoutTemplate className="size-4" />}
				<span className={cn('text-sm')}>New Layout</span>
			</div>
			<Switch checked={showNewLayout} onCheckedChange={handleToggle} />
		</div>
	);
};

export default LayoutSwitcher;
